import {BetlevelMenuModule} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuModule';
import {RecodeEvents} from '@fantasmagames/slot/src/integration/RecodeEvents';

export class RecodeBetlevelMenuModule extends BetlevelMenuModule {
	protected setupEvents(): void {
		super.setupEvents();

		this.on(RecodeEvents.VALIDATED_BET_COIN_SIZE_CHANGED, this.onValidatedBetCoinSizeUpdated);
		this.on(RecodeEvents.VALIDATED_BET, this.onValidatedBet);
	}

	protected onValidatedBetCoinSizeUpdated(): void {
		this.view.betValue = this.logic.betValue;
		this.view.restoreToLastBet(this.view.betValue);
		this.view.lastBet = this.view.betValue;

		this.updateBet();
	}

	protected onValidatedBet(): void {
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/betmenu/recode/RecodeBetlevelMenuModule.ts